(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumb"] && !Shopify.designMode) return;
  try {
    const breadcrumb = document.querySelector('nav[data-noyoco-gender-paths]');
  if (breadcrumb) {
    let genderPaths;
    try {
      genderPaths = JSON.parse(breadcrumb.dataset.noyocoGenderPaths);
    } catch (error) {
      genderPaths = {};
    }

    const updateGenderBreadcrumb = (value) => {
      const gender = ['female', 'femme', 'women', 'woman'].includes(value) ? 'female'
        : ['male', 'homme', 'men', 'man'].includes(value) ? 'male' : null;
      const path = gender && genderPaths[gender];
      const items = breadcrumb.querySelector('ol')?.children;
      if (!path || items?.length !== 4 || breadcrumb.dataset.noyocoBreadcrumbGender === gender) return;

      const targets = [items[1], items[2]].map(item => ({
        link: item.querySelector('a[itemprop="item"]'),
        name: item.querySelector('a [itemprop="name"]')
      }));
      if (targets.some(target => !target.link || !target.name)) return;

      [path.root, path.family].forEach((destination, index) => {
        targets[index].link.setAttribute('href', destination.url);
        targets[index].name.textContent = destination.name;
      });
      breadcrumb.dataset.noyocoBreadcrumbGender = gender;
    };

    document.addEventListener('cart-set-attributes', (event) => {
      updateGenderBreadcrumb(event.detail?.attributes?.gender);
    });
    updateGenderBreadcrumb(new URLSearchParams(window.location.search).get('gender'));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.Shopify.hydrateCartProductProofs) return;

    const proofCache = window.Shopify.cartProductProofCache || {};
    window.Shopify.cartProductProofCache = proofCache;

    const renderProof = (slot, sourceUrl, markup) => {
      if (slot.dataset.cartProductProofUrl !== sourceUrl) return;

      slot.innerHTML = markup;
      slot.hidden = !markup;
      slot.dataset.proofLoadedFor = sourceUrl;
    };

    const loadProof = async (slot) => {
      const sourceUrl = slot.dataset.cartProductProofUrl;

      if (!sourceUrl || slot.dataset.proofLoadedFor === sourceUrl || slot.dataset.proofLoadingFor === sourceUrl) return;

      if (Object.prototype.hasOwnProperty.call(proofCache, sourceUrl)) {
        renderProof(slot, sourceUrl, proofCache[sourceUrl]);
        return;
      }

      slot.dataset.proofLoadingFor = sourceUrl;

      try {
        const requestUrl = new URL(sourceUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', 'cart-product-proof');

        const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewThemeId) requestUrl.searchParams.set('preview_theme_id', previewThemeId);

        const response = await fetch(requestUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load product proof');

        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const proof = parsed.querySelector('[data-cart-product-proof-content]');
        const markup = proof ? proof.outerHTML : '';

        proofCache[sourceUrl] = markup;
        renderProof(slot, sourceUrl, markup);
      } catch (error) {
        slot.hidden = true;
      } finally {
        delete slot.dataset.proofLoadingFor;
      }
    };

    const hydrateProofs = () => {
      window.requestAnimationFrame(() => {
        document.querySelectorAll('#minicart [data-cart-product-proof-url]').forEach(loadProof);
      });
    };

    window.Shopify.hydrateCartProductProofs = hydrateProofs;

    const initializeProofs = () => {
      const minicart = document.querySelector('#minicart');
      if (!minicart) return;

      new MutationObserver(hydrateProofs).observe(minicart, { childList: true, subtree: true });
      hydrateProofs();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProofs, { once: true });
    } else {
      initializeProofs();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-care-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noyoco-care')) {
  class NoyocoCare extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      this.results = this.querySelector('[data-care-results]');
      this.detail = this.querySelector('[data-care-detail]');
      this.status = this.querySelector('[data-care-status]');
      this.detailStatus = this.querySelector('[data-care-detail-status]');
      this.recovery = this.querySelector('[data-care-recovery]');
      this.form = this.querySelector('[data-care-search]');
      this.intent = 'pieces';
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => this.click(event), options);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(this.dataset.searchUrl, location.origin);
        new FormData(this.form).forEach((value, key) => url.searchParams.set(key, value));
        this.search(url);
      }, options);
      window.addEventListener('popstate', () => this.render(false, true), options);
      window.addEventListener('hashchange', () => {
        if (this.renderedHash !== location.hash) this.render(true, true);
      }, options);
      this.render(false, false);
      this.addEventListener('pointerover', event => {
        if (event.target.closest('[data-care-route="echanges-retours"], [data-care-portal]')) this.warmPortal();
      }, options);
      this.addEventListener('focusin', event => {
        if (event.target.closest('[data-care-route="echanges-retours"], [data-care-portal]')) this.warmPortal();
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.searchRequest?.abort();
      this.productRequest?.abort();
      clearTimeout(this.portalTimer);
      clearInterval(this.portalBrandTimer);
      this.portalObserver?.disconnect();
      this.portalObserver = null;
      this.initialized = false;
    }
    remember() {
      history.replaceState({ ...history.state, ncare: { ...history.state?.ncare, scroll: window.scrollY } }, '', location.href);
    }
    navigate(hash, state = {}) {
      this.remember();
      history.pushState({ ...history.state, ncare: state }, '', hash);
      this.render(true, false);
    }
    render(focus, restore) {
      this.renderedHash = location.hash;
      const match = location.hash.match(/^#piece\/([a-zA-Z0-9_-]+)\/(pieces|entretien|taille)$/);
      const name = location.hash.slice(1);
      const selected = match ? 'detail' : ['aide', 'echanges-retours'].includes(name) ? name : 'orders';
      this.screen = selected;
      this.dataset.careScreen = selected;
      this.querySelectorAll('[data-care-panel]').forEach(panel => panel.hidden = panel.dataset.carePanel !== selected);
      this.querySelectorAll('[data-care-route]').forEach(link => {
        if (link.dataset.careRoute === selected) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (match) {
        this.intent = match[2];
        const root = this.dataset.rootUrl.replace(/\/$/, '');
        this.product(root + '/products/' + match[1], focus || restore);
        return;
      }
      if (selected === 'echanges-retours') this.warmPortal();
      this.productRequest?.abort();
      this.detail.removeAttribute('aria-busy');
      if (['pieces', 'entretien', 'taille'].includes(name)) this.intent = name;
      const panel = this.querySelector('[data-care-panel="' + selected + '"]');
      const y = restore ? history.state?.ncare?.scroll : undefined;
      if (Number.isFinite(y)) {
        requestAnimationFrame(() => {
          if (this.screen !== selected) return;
          if (selected === 'orders' && this.lastTrigger?.isConnected) this.lastTrigger.focus({ preventScroll: true });
          window.scrollTo({ top: y, behavior: 'instant' });
        });
      } else if (focus) {
        panel?.querySelector('h2')?.focus({ preventScroll: true });
        panel?.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }
    warmPortal() {
      if (!this.initialized || navigator.connection?.saveData) return;
      window.noyocoLoadReturnPortal().catch(() => {});
    }
    applyPortalBrand() {
      const shadow = document.querySelector('baback-return')?.shadowRoot;
      if (!shadow) return false;
      const template = document.querySelector('template[data-baback-theme]');
      if (template && !shadow.querySelector('#noyoco-baback-theme')) shadow.append(template.content.firstElementChild.cloneNode(true));
      const identified = shadow.querySelectorAll('input').length >= 2;
      if (identified) {
        const title = shadow.querySelector('.text-2xl.font-semibold');
        const intro = shadow.querySelector('.text-sm.font-light.text-gray-500');
        if (title) title.textContent = this.dataset.portalTitle;
        if (intro) intro.textContent = this.dataset.portalIntro;
      }
      const close = Array.from(shadow.querySelectorAll('.sr-only')).find(item => item.textContent.trim() === 'Close');
      if (close) close.textContent = this.dataset.portalClose;
      this.syncPortalMobileClose(shadow);
      if (!this.portalObserver) {
        this.portalObserver = new MutationObserver(() => this.syncPortalMobileClose(shadow));
        this.portalObserver.observe(shadow, { childList: true, subtree: true });
      }
      return identified;
    }
    syncPortalMobileClose(shadow) {
      const header = shadow.querySelector('.react-modal-sheet-header');
      const identified = shadow.querySelector('input[placeholder="#00001"]');
      const existing = shadow.querySelector('[data-noyoco-portal-close]');
      if (!identified || !header) {
        existing?.remove();
        return;
      }
      if (existing) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.noyocoPortalClose = '';
      button.textContent = this.dataset.portalClose;
      const options = { signal: this.events.signal };
      button.addEventListener('pointerdown', event => event.stopPropagation(), options);
      button.addEventListener('click', event => {
        event.stopPropagation();
        if (!shadow.querySelector('input[placeholder="#00001"]')) return;
        if (typeof window.baback?.close !== 'function') return;
        window.baback.close();
        this.querySelector('[data-care-portal]')?.focus({ preventScroll: true });
      }, options);
      header.append(button);
    }
    async showPortal(link) {
      if (this.portalOpening) return;
      this.portalOpening = true;
      const status = this.querySelector('[data-care-portal-status]');
      status.textContent = this.dataset.loading;
      link.setAttribute('aria-busy', 'true');
      try {
        await window.noyocoLoadReturnPortal();
        if (!this.isConnected) return;
        window.baback.openPopup();
        status.textContent = '';
        let attempts = 0;
        clearInterval(this.portalBrandTimer);
        this.portalBrandTimer = setInterval(() => {
          if (!this.isConnected || this.applyPortalBrand()) {
            clearInterval(this.portalBrandTimer);
          } else if (++attempts >= 100) {
            clearInterval(this.portalBrandTimer);
            this.portalFailed = true;
            status.textContent = this.dataset.error;
          }
        }, 100);
      } catch (error) {
        this.portalFailed = true;
        status.textContent = this.dataset.error;
      } finally {
        this.portalOpening = false;
        link.removeAttribute('aria-busy');
      }
    }
    click(event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button && event.button !== 0)) return;
      const portal = event.target.closest('[data-care-portal]');
      if (portal) {
        if (this.portalFailed) return;
        event.preventDefault();
        event.stopPropagation();
        this.showPortal(portal);
        return;
      }
      const back = event.target.closest('[data-care-back]');
      if (back) {
        event.preventDefault();
        if (history.state?.ncare?.fromList) history.back();
        else this.navigate('#orders');
        return;
      }
      const route = event.target.closest('[data-care-route]');
      if (route) {
        event.preventDefault();
        this.navigate('#' + route.dataset.careRoute);
        return;
      }
      const product = event.target.closest('[data-care-product-url]');
      if (product) {
        const url = new URL(product.dataset.careProductUrl, location.origin);
        const handle = url.pathname.match(/\/products\/([a-zA-Z0-9_-]+)\/?$/)?.[1];
        if (url.origin !== location.origin || !handle) return;
        event.preventDefault();
        this.lastTrigger = product;
        const intent = product.dataset.careIntent || this.intent;
        this.navigate('#piece/' + handle + '/' + (['pieces', 'entretien', 'taille'].includes(intent) ? intent : 'pieces'), { fromList: true, fromSearch: Boolean(product.closest('[data-care-results]')) });
        return;
      }
      const pagination = event.target.closest('.ncare-pagination a');
      if (pagination) {
        event.preventDefault();
        this.search(new URL(pagination.href));
      }
    }
    async fragment(url, section, selector, signal) {
      if (url.origin !== location.origin) throw new Error('Invalid source');
      url.searchParams.set('section_id', section);
      url.searchParams.delete('view');
      const response = await fetch(url, { signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fragment = document.querySelector(selector);
      if (!fragment) throw new Error('Missing section');
      return fragment;
    }
    async search(url) {
      this.searchRequest?.abort();
      this.searchRequest = new AbortController();
      const request = this.searchRequest;
      this.status.textContent = this.dataset.loading;
      this.results.setAttribute('aria-busy', 'true');
      try {
        const fragment = await this.fragment(url, 'noyoco-care-search', '[data-care-search-response]', request.signal);
        if (request.signal.aborted) return;
        this.results.replaceChildren(fragment);
        this.status.textContent = fragment.querySelector('.ncare-product-card') ? this.dataset.results : '';
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.results.replaceChildren();
        this.status.textContent = this.dataset.error;
      } finally {
        if (!request.signal.aborted) this.results.removeAttribute('aria-busy');
      }
    }
    async product(path, focus) {
      this.productRequest?.abort();
      this.productRequest = new AbortController();
      const request = this.productRequest;
      this.detailStatus.textContent = this.dataset.loading;
      this.recovery.hidden = false;
      this.detail.hidden = true;
      this.detail.setAttribute('aria-busy', 'true');
      try {
        if (this.detailPath !== path || !this.detail.firstElementChild) {
          const fragment = await this.fragment(new URL(path, location.origin), 'noyoco-care-product', '[data-care-product-response]', request.signal);
          if (request.signal.aborted || this.screen !== 'detail') return;
          this.detail.replaceChildren(fragment);
          this.detailPath = path;
        }
        if (request.signal.aborted || this.screen !== 'detail') return;
        this.detail.querySelectorAll('[data-care-topic]').forEach(topic => topic.open = topic.dataset.careTopic === this.intent);
        const back = this.detail.querySelector('[data-care-back]');
        if (back) {
          if (!back.dataset.originalLabel) back.dataset.originalLabel = back.textContent;
          back.textContent = history.state?.ncare?.fromSearch ? '← ' + this.dataset.backSearch : back.dataset.originalLabel;
        }
        this.detailStatus.textContent = '';
        this.recovery.hidden = true;
        this.detail.hidden = false;
        if (focus) {
          this.detail.querySelector('h2')?.focus({ preventScroll: true });
          this.querySelector('[data-care-panel="detail"]').scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.detailStatus.textContent = this.dataset.error;
        this.detailPath = null;
        this.detail.replaceChildren();
      } finally {
        if (!request.signal.aborted) this.detail.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('noyoco-care', NoyocoCare);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-color-filter"] && !Shopify.designMode) return;
  try {
    if (!window.noyocoColorFilterReady) {
    window.noyocoColorFilterReady = true;
    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-noyoco-color-values]');
      if (!control || control.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      const parameter = control.dataset.noyocoColorParam;
      const values = control.dataset.noyocoColorValues.split('||').filter(Boolean);
      if (!parameter || values.length === 0) return;

      const url = new URL(window.location.href);
      const currentValues = url.searchParams.getAll(parameter);
      const retainedValues = currentValues.filter((value) => !values.includes(value));
      const groupIsActive = values.some((value) => currentValues.includes(value));

      url.searchParams.delete(parameter);
      [...new Set(retainedValues)].forEach((value) => url.searchParams.append(parameter, value));
      if (!groupIsActive) {
        values.forEach((value) => url.searchParams.append(parameter, value));
      }
      url.searchParams.delete('page');

      const collection = document.querySelector('kercambre-collection');
      if (collection && typeof collection.getNewCollectionPage === 'function') {
        collection.getNewCollectionPage(url.href);
      } else {
        window.location.assign(`${url.pathname}${url.search}${url.hash}`);
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-concierge-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.querySelector('#noyoco-concierge');if(!root)return;
  const dialog=root.querySelector('dialog'),launch=root.querySelector('.nc-launch'),input=root.querySelector('#nc-question'),log=root.querySelector('.nc-conversation'),feedback=root.querySelector('.nc-feedback'),scroll=root.querySelector('.nc-scroll'),form=root.querySelector('.nc-form'),submit=form.querySelector('button'),topics=root.querySelector('.nc-topics'),welcome=root.querySelector('.nc-welcome');
  const copy=Object.fromEntries([...root.querySelector('#nc-copy').content.querySelectorAll('[data-copy]')].map(e=>[e.dataset.copy,e.textContent]));
  const api=root.dataset.api;const storageKey='noyoco-concierge-v2:'+api;
  let state={sessionId:'',messages:[],expires:0},busy=false,controller=null,epoch=0,accessCode='';
  let measureEntry='unknown';
  const measureQa=new URLSearchParams(window.location.search).get('noyoco_concierge_qa')==='1';
  const measureNames=new Set(['concierge_open','concierge_request','concierge_response','concierge_product_click','concierge_service_click','concierge_error']);
  const trackConcierge=(name,extra={})=>{
    try{
      const privacy=window.Shopify?.customerPrivacy;
      if(!measureNames.has(name)||root.dataset.designMode==='true'||!privacy||privacy.analyticsProcessingAllowed()!==true||privacy.currentVisitorConsent().analytics!=='yes'||typeof window.gtag!=='function')return;
      if(document.querySelector('#PBarNextFrame, #preview-bar-iframe')&&!measureQa)return;
      const lang=String(document.documentElement.lang||'').toLowerCase();
      const params={send_to:'G-47FH6SFMQ2',concierge_locale:/^[a-z]{2}(?:-[a-z]{2})?$/.test(lang)?lang:'other',concierge_entry_point:measureEntry,concierge_release:'20261011b',concierge_qa:measureQa?1:0};
      const categories={concierge_source:['typed','topic','recreate'],concierge_result:['products','text','handoff'],concierge_destination_type:['shipping','refund','returns','account','email','size_guide'],concierge_error_category:['timeout','quota','session','configuration','invalid_response','service','access']};
      for(const [key,values] of Object.entries(categories))if(values.includes(extra[key]))params[key]=extra[key];
      for(const key of ['concierge_has_products','concierge_visible'])if(extra[key]===0||extra[key]===1)params[key]=extra[key];
      if(Number.isFinite(extra.concierge_latency_ms))params.concierge_latency_ms=Math.max(0,Math.min(90000,Math.round(extra.concierge_latency_ms)));
      if(typeof extra.concierge_product_handle==='string'&&/^[a-z0-9][a-z0-9-]{0,99}$/.test(extra.concierge_product_handle))params.concierge_product_handle=extra.concierge_product_handle;
      if(measureQa)params.debug_mode=true;
      window.gtag('event',name,params);
    }catch{}
  };
  const measureProductHandle=url=>{
    try{const u=new URL(url,'https://noyoco.com');return u.protocol==='https:'&&u.hostname==='noyoco.com'&&!u.username&&!u.password?u.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([a-z0-9][a-z0-9-]{0,180})\/?$/i)?.[1]||'':'';}catch{return '';}
  };
  const measureDestination=url=>{
    try{
      const u=new URL(url,'https://noyoco.com');if(u.username||u.password)return '';
      if(u.protocol==='mailto:'&&u.pathname==='shop@noyoco.com')return 'email';
      if(u.protocol!=='https:')return '';
      if(u.hostname==='account.noyoco.com')return 'account';
      if(u.hostname!=='noyoco.com')return '';
      const path=u.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//i,'/').replace(/\/$/,'');
      return {'/policies/shipping-policy':'shipping','/policies/refund-policy':'refund','/pages/return':'returns','/account':'account'}[path]||'';
    }catch{return '';}
  };
  root.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const link=event.target.closest('a');if(!link||!root.contains(link))return;
    const handle=measureProductHandle(link.href);
    if(handle)trackConcierge('concierge_product_click',{concierge_product_handle:handle});
    else{const destination=measureDestination(link.href);if(destination)trackConcierge('concierge_service_click',{concierge_destination_type:destination});}
  });
  try{const saved=JSON.parse(sessionStorage.getItem(storageKey));if(saved?.expires>Date.now()&&Array.isArray(saved.messages))state=saved;else if(saved?.draft?.expires>Date.now())state.draft=saved.draft;accessCode=sessionStorage.getItem(storageKey+':access')||'';}catch{}
  if(state.draft?.expires>Date.now())input.value=state.draft.text;
  const save=()=>{try{sessionStorage.setItem(storageKey,JSON.stringify(state));}catch{}};
  const redact=s=>s.replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi,'[email masqué]').replace(/\bsk-[a-zA-Z0-9_-]{10,}\b/g,'[clé masquée]').replace(/\b(?:\+?\d[ .()-]?){9,19}\b/g,'[numéro masqué]');
  const headers=()=>({'Content-Type':'application/json',...(state.sessionId?{Authorization:'Bearer '+state.sessionId}:{}),...(accessCode?{'X-Preview-Code':accessCode}:{})});
  const atBottom=()=>scroll.scrollTop=scroll.scrollHeight;
  const allowedLink=url=>{try{const u=new URL(url);return(u.protocol==='https:'&&['noyoco.com','account.noyoco.com'].includes(u.hostname)&&!u.username&&!u.password)||(url==='mailto:shop@noyoco.com');}catch{return false;}};
  const productLink=url=>{try{const u=new URL(url);return u.protocol==='https:'&&u.hostname==='noyoco.com'&&!u.username&&!u.password&&/^\/products\/[a-z0-9-]+$/.test(u.pathname)&&!u.search&&!u.hash;}catch{return false;}};
  const localLink=url=>{
    try{
      const u=new URL(url),route=new URL(root.dataset.routeRoot||'/', 'https://noyoco.com');
      if(u.protocol!=='https:'||u.hostname!=='noyoco.com'||u.username||u.password||route.origin!=='https://noyoco.com'||route.search||route.hash||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/?$/i.test(route.pathname))return url;
      const path=u.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?((?:products|pages|policies|collections)\/.+)$/i);
      if(!path)return url;
      u.pathname=route.pathname.replace(/\/$/,'')+'/'+path[1];return u.href;
    }catch{return url;}
  };
  const imageLink=url=>{try{const u=new URL(url);return u.protocol==='https:'&&!u.username&&!u.password&&((u.hostname==='cdn.shopify.com'&&u.pathname.startsWith('/s/files/1/0755/1551/'))||(u.hostname==='noyoco.com'&&u.pathname.startsWith('/cdn/shop/')));}catch{return false;}};
  function productCard(product){
    if(!productLink(product.url))return null;
    const card=document.createElement('article');card.className='nc-card';
    const link=document.createElement('a');link.className='nc-card-link';link.href=localLink(product.url);link.rel='noopener noreferrer';
    if(product.image?.kind==='packshot'&&imageLink(product.image.url)){
      const img=document.createElement('img');img.src=product.image.url;img.alt=product.title+' · NOYOCO';img.loading='lazy';img.decoding='async';img.referrerPolicy='no-referrer';img.width=300;img.height=400;link.append(img);
    }
    if(product.role){const role=document.createElement('span');role.className='nc-card-role';role.textContent=product.role;link.append(role);}
    const title=document.createElement('span');title.className='nc-card-title';title.textContent=product.title;link.append(title);
    if(Number.isFinite(product.price)){const price=document.createElement('span');price.className='nc-card-price';price.textContent=(product.priceVaries?(copy.from_price||'À partir de')+' ':'')+new Intl.NumberFormat(copy.you==='You'?'en-GB':'fr-FR',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(product.price);link.append(price);}
    const cta=document.createElement('span');cta.className='nc-card-cta';cta.textContent=(copy.view_product||'Voir la pièce')+' ↗';link.append(cta);card.append(link);
    const stock=document.createElement('p');stock.className='nc-card-stock';stock.textContent=product.available?(copy.available_sizes||'Tailles en ligne')+' : '+(product.availableSizes||[]).join(', '):(copy.sold_out||'Indisponible en ligne');card.append(stock);
    return card;
  }
  function productGrid(products){const grid=document.createElement('div');grid.className='nc-products';for(const p of products||[]){const card=productCard(p);if(card)grid.append(card);}return grid;}
  function selectionBlock(selection){
    const section=document.createElement('section');section.className='nc-selection';
    if(selection.title){const title=document.createElement('h3');title.textContent=selection.title;section.append(title);}
    if(selection.description){const description=document.createElement('p');description.textContent=selection.description;section.append(description);}
    section.append(productGrid(selection.products));
    if(selection.stylingNote){const note=document.createElement('p');note.className='nc-styling-note';note.textContent=selection.stylingNote;section.append(note);}
    if(selection.alternatives?.length){
      const details=document.createElement('details');details.className='nc-colors';const summary=document.createElement('summary');summary.textContent=copy.other_colors||'Explorer les autres couleurs';details.append(summary);
      for(const alternative of selection.alternatives){
        const heading=document.createElement('p');heading.className='nc-color-label';heading.textContent=alternative.label;details.append(heading,productGrid(alternative.products));
        const button=document.createElement('button');button.type='button';button.className='nc-recreate';button.textContent=(copy.recreate_look||'Recréer cette tenue')+' · '+alternative.label;
        button.addEventListener('click',()=>sendMessage((copy.recreate_request||'Recrée cette suggestion avec ces pièces :')+' '+selection.title+' — '+alternative.products.map(p=>p.title).join(', ')+'.','recreate'));details.append(button);
      }
      section.append(details);
    }
    return section;
  }
  function message(item){
    const div=document.createElement('div');div.className='nc-message'+(item.role==='user'?' nc-message--question':'');
    const name=document.createElement('strong');name.textContent=item.role==='user'?copy.you:copy.us;div.append(name);
    const text=document.createElement('div');text.className='nc-message-text';text.textContent=item.text;div.append(text);
    for(const selection of item.selections||[])div.append(selectionBlock(selection));
    const cardUrls=new Set((item.selections||[]).flatMap(s=>[...(s.products||[]),...(s.alternatives||[]).flatMap(a=>a.products||[])].map(p=>p.url)));
    for(const link of item.links??[]){if(cardUrls.has(link.url)||!allowedLink(link.url))continue;const a=document.createElement('a');a.href=localLink(link.url);a.textContent=link.label;a.rel='noopener noreferrer';div.append(a);}
    if(item.handoff&&item.handoff!=='none'){
      const note=document.createElement('p');note.className='nc-handoff-note';note.textContent=copy.handoff_note;div.append(note);
      const email=document.createElement('a');email.textContent=copy.handoff_cta;email.href='mailto:shop@noyoco.com?subject='+encodeURIComponent('NOYOCO · Demande de service')+'&body='+encodeURIComponent('Bonjour,\n\n'+(item.summary||item.text)+'\n\nMerci.');div.append(email);
    }
    if(item.closingQuestion){const closing=document.createElement('p');closing.className='nc-closing';closing.textContent=item.closingQuestion;div.append(closing);}
    log.append(div);return div;
  }
  function paint(){log.replaceChildren();state.messages.forEach(message);welcome.hidden=state.messages.length>0;topics.hidden=state.messages.length>0;if(state.messages.length)atBottom();else scroll.scrollTop=0;}
  function loading(value){busy=value;submit.disabled=value;input.disabled=value;form.setAttribute('aria-busy',String(value));root.querySelectorAll('[data-prompt]').forEach(b=>b.disabled=value);}
  function feedbackText(error){return error==='provider_billing'?copy.billing:error==='not_configured'||error==='provider_auth'?copy.not_configured:error==='session_expired'||error==='conversation_limit'?copy.session_expired:error==='timeout'?copy.timeout:error==='network_unavailable'||error==='provider_unavailable'||error==='service_unavailable'?(copy.unavailable||copy.error):error==='provider_quota'||error==='daily_limit'||error==='rate_limit'||error==='hourly_limit'||error==='visitor_limit'||error==='capacity_limit'?copy.limit:copy.error;}
  function failed(value,pending,code,reference){
    state.messages=state.messages.filter(item=>item!==pending);
    if(code==='session_expired'||code==='conversation_limit'){state.sessionId='';state.expires=0;}
    const safeReference=/^NC-[A-F0-9]{8}$/.test(reference||'')?reference:'';
    feedback.textContent=feedbackText(code)+(safeReference?' ('+safeReference+')':'');
    const email=document.createElement('a');email.textContent=copy.handoff_cta;email.style.display='block';email.style.marginTop='12px';
    email.href='mailto:shop@noyoco.com?subject='+encodeURIComponent('NOYOCO · Conseil')+'&body='+encodeURIComponent(pending.text+(safeReference?'\n\n'+safeReference:''));feedback.append(email);
    input.value=value;paint();save();atBottom();
    const category=['timeout'].includes(code)?'timeout':['provider_quota','daily_limit','rate_limit','hourly_limit','visitor_limit','capacity_limit'].includes(code)?'quota':['session_expired','conversation_limit'].includes(code)?'session':['not_configured','provider_auth','provider_billing'].includes(code)?'configuration':code==='invalid_response'?'invalid_response':'service';
    trackConcierge('concierge_error',{concierge_error_category:category,concierge_visible:dialog.open?1:0});
  }
  async function sendMessage(value,source='typed'){
    if(busy||!value.trim())return;
    if(!api){feedback.textContent=copy.not_configured;return;}
    const version=epoch;const requestController=new AbortController();controller=requestController;const timeout=setTimeout(()=>requestController.abort(),80000);
    loading(true);feedback.textContent=copy.thinking;
    const submitted=redact(value.trim());input.value='';
    const requestId=state.draft?.text===submitted&&state.draft?.expires>Date.now()?state.draft.requestId:crypto.randomUUID();
    state.draft={text:submitted,requestId,expires:Date.now()+1800000};save();
    const pending={role:'user',text:submitted};state.messages.push(pending);paint();
    const requestStarted=performance.now();
    trackConcierge('concierge_request',{concierge_source:['typed','topic','recreate'].includes(source)?source:'typed'});
    try{
      const response=await fetch(api+'/chat',{method:'POST',headers:headers(),signal:requestController.signal,body:JSON.stringify({message:submitted,productHandle:root.dataset.productHandle||'',requestId})});
      let data;try{data=await response.json();}catch{throw new Error('service_unavailable');}if(version!==epoch)return;
      if(!response.ok){
        if(data.error==='preview_access_required'){root.querySelector('.nc-access').hidden=false;feedback.textContent=copy.access_required;root.querySelector('#nc-access-code').focus();trackConcierge('concierge_error',{concierge_error_category:'access',concierge_visible:dialog.open?1:0});}
        else{failed(value,pending,data.error,data.reference);return;}
        input.value=value;state.messages=state.messages.filter(item=>item!==pending);paint();save();return;
      }
      if(typeof data.message!=='string'||typeof data.sessionId!=='string')throw new Error('invalid_response');
      state.sessionId=data.sessionId;state.expires=Date.now()+data.expiresIn*1000;
      delete state.draft;
      const item={role:'assistant',text:data.message,selections:data.selections||[],closingQuestion:data.closingQuestion||'',links:data.links,handoff:data.handoff,summary:data.handoff_summary};state.messages.push(item);const answer=message(item);save();feedback.textContent='';if(answer.getBoundingClientRect&&scroll.getBoundingClientRect)scroll.scrollTop+=answer.getBoundingClientRect().top-scroll.getBoundingClientRect().top-16;else atBottom();
      const hasProducts=answer.querySelectorAll('.nc-card').length>0;
      trackConcierge('concierge_response',{concierge_has_products:hasProducts?1:0,concierge_result:item.handoff&&item.handoff!=='none'?'handoff':hasProducts?'products':'text',concierge_latency_ms:performance.now()-requestStarted,concierge_visible:dialog.open?1:0});
    }catch(error){if(version!==epoch)return;failed(value,pending,error.name==='AbortError'?'timeout':error.message==='service_unavailable'?'service_unavailable':error.name==='TypeError'?'network_unavailable':'invalid_response');}
    finally{clearTimeout(timeout);if(version===epoch){loading(false);if(dialog.open)input.focus();}}
  }
  let dialogLauncher=launch;
  let directGuideTrigger=null;
  const guideAction=root.querySelector('[data-noyoco-guide-direct]');
  const findPublishedGuide=()=>{
    const guide=document.querySelector('#product-options .noyoco-size-guide-trigger');
    return guide&&guide.isConnected&&!guide.disabled&&guide.getClientRects().length?guide:null;
  };
  const setLaunchState=expanded=>{
    launch.setAttribute('aria-expanded',String(expanded));
    document.querySelectorAll('[data-noyoco-concierge-open]').forEach(button=>button.setAttribute('aria-expanded',String(expanded)));
  };
  const openConcierge=trigger=>{
    if(dialog.open)return;
    if(guideAction)guideAction.hidden=!findPublishedGuide();
    dialogLauncher=trigger;
    dialog.showModal();setLaunchState(true);atBottom();input.focus();
    measureEntry=trigger===launch?(launch.classList.contains('nc-launch--inline-cart')?'cart':'desktop'):trigger.classList.contains('noyoco-cart-summary__service-button')?'cart':'menu';
    trackConcierge('concierge_open');
  };
  launch.addEventListener('click',()=>openConcierge(launch));
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const trigger=event.target.closest('[data-noyoco-concierge-open]');
    if(trigger)openConcierge(trigger);
  });
  root.querySelector('.nc-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{
    setLaunchState(false);
    if(directGuideTrigger){
      const guide=directGuideTrigger;directGuideTrigger=null;
      // Close the existing mobile menu before opening the native product guide.
      window.dispatchEvent(new CustomEvent('noyoco-guide-from-chat'));
      requestAnimationFrame(()=>{if(guide.isConnected){guide.focus({preventScroll:true});guide.click();}});
    }else if(dialogLauncher.isConnected)dialogLauncher.focus();
  });
  guideAction?.addEventListener('click',()=>{
    if(!dialog.open||directGuideTrigger)return;
    const guide=findPublishedGuide();
    if(!guide){guideAction.hidden=true;return;}
    directGuideTrigger=guide;
    trackConcierge('concierge_service_click',{concierge_destination_type:'size_guide'});
    dialog.close();
  });
  root.querySelector('.nc-reset').addEventListener('click',()=>{const previousHeaders=headers();epoch++;controller?.abort();if(api&&state.sessionId)fetch(api+'/session',{method:'DELETE',headers:previousHeaders}).catch(()=>{});state={sessionId:'',messages:[],expires:0};save();loading(false);input.value='';feedback.textContent='';paint();input.focus();});
  root.querySelectorAll('[data-prompt]').forEach(b=>b.addEventListener('click',()=>sendMessage(b.dataset.prompt,'topic')));
  form.addEventListener('submit',e=>{e.preventDefault();sendMessage(input.value);});
  root.querySelector('.nc-access').addEventListener('submit',e=>{e.preventDefault();accessCode=root.querySelector('#nc-access-code').value;root.querySelector('#nc-access-code').value='';try{sessionStorage.setItem(storageKey+':access',accessCode);}catch{}root.querySelector('.nc-access').hidden=true;feedback.textContent='';input.focus();});
  paint();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-durability-filter"] && !Shopify.designMode) return;
  try {
    if (!window.noyocoCircularFilterReady) {
    window.noyocoCircularFilterReady = true;

    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-noyoco-circular-filter]');
      if (!control) return;

      const input = control.querySelector('input');
      if (!input || input.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const parameter = control.dataset.noyocoCircularParam;
      const values = control.dataset.noyocoCircularValues.split('||').filter(Boolean);
      if (!parameter || values.length === 0) return;

      const url = new URL(window.location.href);
      const currentValues = url.searchParams.getAll(parameter);
      const retainedValues = currentValues.filter((value) => !values.includes(value));
      const groupIsActive = values.some((value) => currentValues.includes(value));

      url.searchParams.delete(parameter);
      [...new Set(retainedValues)].forEach((value) => url.searchParams.append(parameter, value));

      if (!groupIsActive) {
        values.forEach((value) => url.searchParams.append(parameter, value));
      }

      url.searchParams.delete('page');
      window.location.assign(`${url.pathname}${url.search}${url.hash}`);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-facet-group"] && !Shopify.designMode) return;
  try {
    if (!window.noyocoFacetGroupsReady) {
    window.noyocoFacetGroupsReady = true;
    document.addEventListener('click', event => {
      const control = event.target.closest('[data-noyoco-facet-group]');
      const input = control?.querySelector('input');
      if (!input || input.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const parameter = control.dataset.param;
      const values = [...new Set(control.dataset.values.split('||').filter(Boolean))];
      if (!parameter || !values.length) return;
      const url = new URL(location.href);
      const current = url.searchParams.getAll(parameter);
      const retained = current.filter(value => !values.includes(value));
      const selected = values.some(value => current.includes(value));
      url.searchParams.delete(parameter);
      [...new Set(retained)].forEach(value => url.searchParams.append(parameter, value));
      if (!selected) values.forEach(value => url.searchParams.append(parameter, value));
      url.searchParams.delete('page');
      location.assign(url.pathname + url.search + url.hash);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-impact-benchmark"] && !Shopify.designMode) return;
  try {
    (() => {
    const numberFormatter = (locale, options) => new Intl.NumberFormat(locale, options);

    const formatMetric = (value, key, locale) => {
      const formats = {
        ecs: { maximumFractionDigits: 0 },
        cch: { minimumFractionDigits: 1, maximumFractionDigits: 1 },
        wtu: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      };
      const units = { ecs: ' pts', cch: ' kg CO₂e', wtu: ' m³' };
      return numberFormatter(locale, formats[key] || {}).format(value) + (units[key] || '');
    };

    const initImpactModel = (root) => {
      if (root.dataset.impactInitialized === 'true') return;
      root.dataset.impactInitialized = 'true';

      const locale = document.documentElement.lang || 'fr-FR';
      const map = root.closest('.noyoco-story__chapter--journey')?.querySelector('[data-noyoco-route-map]');
      const distanceOutput = root.querySelector('[data-impact-distance]');
      const sourceDistance = map?.querySelector('[data-map-fabric-distance]');

      const syncDistance = () => {
        const distance = sourceDistance?.textContent.trim();
        if (distance && distance !== '—') distanceOutput.textContent = distance;
      };
      syncDistance();
      if (sourceDistance) {
        new MutationObserver(syncDistance).observe(sourceDistance, { childList: true, characterData: true, subtree: true });
      }

      if (root.dataset.canSimulate !== 'true') return;

      const parseQuery = (name) => JSON.parse(root.querySelector(`[data-impact-query="${name}"]`).textContent);
      const actualQuery = parseQuery('actual');
      const referenceQuery = parseQuery('reference');
      const precomputedNode = root.querySelector('[data-impact-precomputed]');
      const precomputed = precomputedNode ? JSON.parse(precomputedNode.textContent) : null;
      const endpoint = root.dataset.endpoint;
      const errorOutput = root.querySelector('[data-impact-error]');
      const resultLink = root.querySelector('[data-impact-web-url]');
      const state = { activeView: 'actual', actual: null, reference: null };

      const requestImpact = async (query) => {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(query),
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Ecobalyse ${response.status}`);
          const payload = await response.json();
          if (!payload?.impacts) throw new Error('Ecobalyse response has no impacts');
          return payload;
        } finally {
          window.clearTimeout(timeout);
        }
      };

      const comparisonLabel = (actual, reference) => {
        if (!Number.isFinite(actual) || !Number.isFinite(reference) || reference <= 0) return '';
        const difference = ((reference - actual) / reference) * 100;
        if (Math.abs(difference) < 0.5) return root.dataset.equalLabel;
        const percent = numberFormatter(locale, { maximumFractionDigits: 0 }).format(Math.abs(difference));
        const template = difference > 0 ? root.dataset.lessTemplate : root.dataset.moreTemplate;
        return template.replace('__PERCENT__', percent);
      };

      const render = () => {
        if (!state.actual || !state.reference) return;
        root.querySelectorAll('[data-impact-key]').forEach((card) => {
          const key = card.dataset.impactKey;
          const actual = Number(state.actual.impacts[key]);
          const reference = Number(state.reference.impacts[key]);
          const visible = state.activeView === 'reference' ? reference : actual;
          const output = card.querySelector('[data-impact-value]');
          const comparison = card.querySelector('[data-impact-comparison]');
          const bar = card.querySelector('[data-impact-bar]');
          if ((key === 'cch' || key === 'wtu') && (!Number.isFinite(actual) || !Number.isFinite(reference) || (actual === 0 && reference === 0))) {
            output.textContent = root.dataset.restrictedLabel;
            comparison.textContent = root.dataset.restrictedHint;
            bar.style.width = '0%';
            card.dataset.metricState = 'restricted';
            return;
          }
          if (Number.isFinite(visible)) output.textContent = formatMetric(visible, key, locale);
          comparison.textContent = comparisonLabel(actual, reference);
          const maximum = Math.max(actual, reference, 0);
          bar.style.width = maximum > 0 ? `${Math.max(4, (visible / maximum) * 100)}%` : '0%';
        });
      };

      root.querySelectorAll('[data-impact-view]').forEach((button) => {
        button.addEventListener('click', () => {
          state.activeView = button.dataset.impactView;
          root.querySelectorAll('[data-impact-view]').forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });
          render();
        });
      });

      if (precomputed?.actual?.ecs && precomputed?.reference?.ecs) {
        state.actual = { impacts: precomputed.actual };
        state.reference = { impacts: precomputed.reference };
        root.dataset.state = 'ready';
        if (resultLink) {
          const encodedScenario = window.btoa(JSON.stringify({ ...actualQuery, upcycled: false }));
          resultLink.href = `https://ecobalyse.beta.gouv.fr/versions/v7.0.0/#/textile/simulator/ecs/${encodedScenario}`;
          resultLink.hidden = false;
        }
        render();
        return;
      }

      Promise.all([requestImpact(actualQuery), requestImpact(referenceQuery)])
        .then(([actual, reference]) => {
          state.actual = actual;
          state.reference = reference;
          root.dataset.state = 'ready';
          if (actual.webUrl && resultLink) {
            resultLink.href = actual.webUrl;
            resultLink.hidden = false;
          }
          render();
        })
        .catch(() => {
          root.dataset.state = 'error';
          errorOutput.textContent = root.dataset.errorLabel;
          errorOutput.hidden = false;
          root.querySelectorAll('[data-impact-value]').forEach((output) => {
            output.textContent = '—';
          });
          root.querySelectorAll('[data-impact-comparison]').forEach((output) => {
            output.textContent = '';
          });
        });
    };

    const initAllImpactModels = (scope = document) => {
      scope.querySelectorAll('[data-noyoco-impact-model]').forEach(initImpactModel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllImpactModels(), { once: true });
    } else {
      initAllImpactModels();
    }
    document.addEventListener('shopify:section:load', (event) => initAllImpactModels(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePopup = () => {
      const popup = document.querySelector('[data-noyoco-newsletter-popup]');

      if (!popup || popup.dataset.initialized === 'true') return;

      popup.dataset.initialized = 'true';

      const legacyFormIds = ['UX9f8n', 'W7ujUY', 'SssFxa', 'VPNNKJ'];
      const form = popup.querySelector('[data-noyoco-popup-form]');
      const emailInput = popup.querySelector('input[type="email"]');
      const submitButton = popup.querySelector('[data-noyoco-popup-submit]');
      const errorMessage = popup.querySelector('[data-noyoco-popup-error]');
      const formView = popup.querySelector('[data-noyoco-popup-form-view]');
      const genderView = popup.querySelector('[data-noyoco-popup-gender]');
      const genderChoices = popup.querySelectorAll('[data-noyoco-popup-gender-choice]');
      const genderSkip = popup.querySelector('[data-noyoco-popup-gender-skip]');
      const successView = popup.querySelector('[data-noyoco-popup-success]');
      const dismissButtons = popup.querySelectorAll('[data-noyoco-popup-dismiss]');
      const storageKey = 'noyoco_aw26_newsletter_dismissed_until';
      const viewKey = 'noyoco_aw26_newsletter_page_views';
      const sessionKey = 'noyoco_aw26_newsletter_seen_this_session';
      const displayCooldownDays = 30;
      const subscribedCooldownDays = 365;
      const query = new URLSearchParams(window.location.search);
      const forceOpen = query.get('noyoco_popup') === '1' || popup.dataset.designMode === 'true';
      const isMobileViewport = () => window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 750;
      const pageType = popup.dataset.pageType || '';
      const suppressAutomaticPopup = () =>
        pageType === 'cart' ||
        document.body.matches('.template-cart') ||
        pageType.startsWith('customers/') ||
        (isMobileViewport() && ['product', 'collection', 'list-collections', 'search'].includes(pageType));
      const interactionInProgress = () => {
        const active = document.activeElement;
        if (active && active.matches('input, textarea, select, [contenteditable="true"]')) return true;
        return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]'))
          .some((element) => element !== popup && !element.hidden && element.getAttribute('aria-hidden') !== 'true' &&
            element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden');
      };
      let completed = false;
      let delayPassed = forceOpen;
      let engaged = forceOpen;
      let triggerTimer;
      let subscribedEmail = '';
      let openReason = forceOpen ? 'forced' : 'delay_engagement';

      const deviceKind =
        window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 750 ? 'mobile' : 'desktop';

      const popupContext = () => ({
        popup_source: 'NOYOCO AW26 newsletter popup',
        popup_locale: (popup.dataset.locale || '').toLowerCase(),
        popup_device: deviceKind,
        popup_page: window.location.pathname,
        popup_trigger: openReason
      });

      // GA4 respects the site's consent mode on its own, and never receives the address.
      const trackGA = (name, params) => {
        if (forceOpen) return;

        try {
          if (typeof window.gtag === 'function') window.gtag('event', name, params || popupContext());
        } catch (error) {
          return;
        }
      };

      // Klaviyo metrics go through the client events API rather than the onsite SDK:
      // the SDK silently drops events when no profile is known yet, the API does not.
      // Only called once the address exists, so the event always lands on a profile.
      const trackKlaviyo = (metricName, extra) => {
        if (forceOpen || !subscribedEmail) return;

        try {
          fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(popup.dataset.companyId), {
            method: 'POST',
            keepalive: true,
            headers: {
              accept: 'application/vnd.api+json',
              'content-type': 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  properties: Object.assign(popupContext(), extra || {}),
                  metric: { data: { type: 'metric', attributes: { name: metricName } } },
                  profile: { data: { type: 'profile', attributes: { email: subscribedEmail } } }
                }
              }
            })
          }).catch(() => {});
        } catch (error) {
          return;
        }
      };

      const readCookieNumber = (key) => {
        const encodedKey = encodeURIComponent(key) + '=';
        const cookie = document.cookie
          .split(';')
          .map((value) => value.trim())
          .find((value) => value.startsWith(encodedKey));

        return cookie ? Number(decodeURIComponent(cookie.slice(encodedKey.length)) || 0) : 0;
      };

      const writeCookieNumber = (key, value) => {
        document.cookie =
          encodeURIComponent(key) +
          '=' +
          encodeURIComponent(String(value)) +
          '; path=/; max-age=34560000; samesite=lax';
      };

      const readStoredNumber = (key) => {
        try {
          const storedValue = Number(window.localStorage.getItem(key) || 0);
          if (storedValue) return storedValue;
        } catch (error) {
          return readCookieNumber(key);
        }

        return readCookieNumber(key);
      };

      const writeStoredNumber = (key, value) => {
        try {
          window.localStorage.setItem(key, String(value));
        } catch (error) {
          // The cookie fallback below preserves the frequency cap when storage is unavailable.
        }

        writeCookieNumber(key, value);
      };

      const readSessionFlag = () => {
        try {
          return window.sessionStorage.getItem(sessionKey) === '1';
        } catch (error) {
          return false;
        }
      };

      const writeSessionFlag = () => {
        try {
          window.sessionStorage.setItem(sessionKey, '1');
        } catch (error) {
          return;
        }
      };

      const storeExpiry = (days) => {
        writeStoredNumber(storageKey, Date.now() + days * 86400000);
      };

      const openPopup = () => {
        if (
          popup.open ||
          (!forceOpen && (suppressAutomaticPopup() || interactionInProgress() || readSessionFlag() || readStoredNumber(storageKey) > Date.now()))
        ) {
          return;
        }

        if (typeof popup.showModal === 'function') {
          popup.showModal();
        } else {
          popup.setAttribute('open', '');
        }

        document.body.classList.add('noyoco-newsletter-popup-open');
        if (!forceOpen) {
          writeSessionFlag();
          storeExpiry(displayCooldownDays);
        }
        window.setTimeout(() => emailInput && emailInput.focus(), 80);
        window.clearTimeout(triggerTimer);
        window.removeEventListener('scroll', handleEngagement);
        document.removeEventListener('mouseout', handleExitIntent);

        trackGA('newsletter_popup_view');
      };

      const closePopup = () => {
        if (!completed) {
          storeExpiry(displayCooldownDays);
          trackGA('newsletter_popup_dismiss');
        }

        if (typeof popup.close === 'function') {
          popup.close();
        } else {
          popup.removeAttribute('open');
        }

        document.body.classList.remove('noyoco-newsletter-popup-open');
      };

      const showSuccess = () => {
        if (genderView) genderView.hidden = true;
        formView.hidden = true;
        successView.hidden = false;

        const successButton = successView.querySelector('button');
        if (successButton) successButton.focus();
      };

      const saveGender = async (value) => {
        if (!subscribedEmail || !value) return;

        try {
          await fetch(
            'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(popup.dataset.companyId),
            {
              method: 'POST',
              headers: {
                accept: 'application/vnd.api+json',
                'content-type': 'application/vnd.api+json',
                revision: '2026-07-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'profile',
                  attributes: {
                    email: subscribedEmail,
                    properties: {
                      gender: value
                    }
                  }
                }
              })
            }
          );
        } catch (error) {
          // The subscription is already recorded at step 1, so a failed gender write is never blocking.
        }
      };

      const maybeOpen = () => {
        if (delayPassed && engaged) openPopup();
      };

      const handleEngagement = () => {
        const pageHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        const threshold = Math.min(640, Math.max(220, pageHeight * 0.14));

        if (window.scrollY >= threshold) {
          engaged = true;
          maybeOpen();
        }
      };

      const handleExitIntent = (event) => {
        if (!isMobileViewport() && event.clientY <= 0 && event.relatedTarget === null) {
          engaged = true;
          delayPassed = true;
          if (!popup.open) openReason = 'exit_intent';
          maybeOpen();
        }
      };

      const completeGender = async (answer) => {
        if (answer !== 'skipped') await saveGender(answer);

        trackGA('newsletter_popup_gender', Object.assign(popupContext(), { popup_gender: answer }));
        trackKlaviyo('Newsletter Popup Gender', { gender: answer });
        showSuccess();
      };

      const suppressLegacyForms = () => {
        let suppressed = false;

        legacyFormIds.forEach((id) => {
          const legacyForm = document.querySelector('form[data-testid="klaviyo-form-' + id + '"]');

          if (!legacyForm) return;

          let current = legacyForm.parentElement;
          let fixedRoot = null;

          while (current && current !== document.body) {
            if (window.getComputedStyle(current).position === 'fixed') {
              fixedRoot = current;
              break;
            }

            current = current.parentElement;
          }

          const target = fixedRoot || legacyForm;
          target.hidden = true;
          target.style.setProperty('display', 'none', 'important');
          suppressed = true;
        });

        if (suppressed && !popup.open) {
          document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
          document.body.classList.remove('klaviyo-prevent-body-scrolling');
          document.documentElement.style.removeProperty('overflow');
          document.body.style.removeProperty('overflow');
        }
      };

      const legacyObserver = new MutationObserver(suppressLegacyForms);
      legacyObserver.observe(document.documentElement, { childList: true, subtree: true });
      suppressLegacyForms();

      if (!forceOpen && (suppressAutomaticPopup() || readSessionFlag() || readStoredNumber(storageKey) > Date.now())) return;

      dismissButtons.forEach((button) => {
        button.addEventListener('click', closePopup);
      });

      genderChoices.forEach((button) => {
        button.addEventListener('click', async () => {
          genderChoices.forEach((choice) => {
            choice.disabled = true;
          });

          await completeGender(button.dataset.noyocoPopupGenderChoice);
        });
      });

      if (genderSkip) {
        genderSkip.addEventListener('click', () => {
          completeGender('skipped');
        });
      }

      popup.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup();
      });

      popup.addEventListener('close', () => {
        document.body.classList.remove('noyoco-newsletter-popup-open');
      });

      popup.addEventListener('click', (event) => {
        if (event.target === popup) closePopup();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        errorMessage.textContent = '';

        if (!emailInput.checkValidity()) {
          emailInput.reportValidity();
          return;
        }

        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.submittingLabel;

        const language = (popup.dataset.locale || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
        const email = emailInput.value.trim();
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'NOYOCO AW26 newsletter popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    locale: language,
                    properties: {
                      lang: language,
                      source: 'NOYOCO AW26 popup'
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: popup.dataset.listId
                }
              }
            }
          }
        };

        try {
          const response = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(popup.dataset.companyId),
            {
              method: 'POST',
              headers: {
                accept: 'application/vnd.api+json',
                'content-type': 'application/vnd.api+json',
                revision: '2026-07-15'
              },
              body: JSON.stringify(payload)
            }
          );

          if (!response.ok) throw new Error('Subscription request failed');

          completed = true;
          subscribedEmail = email;
          storeExpiry(subscribedCooldownDays);

          try {
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
              window.klaviyo.identify({ email: email });
            }
          } catch (identifyError) {
            // Identification is a convenience for attribution, never a blocker.
          }

          trackGA('newsletter_popup_submit');
          trackKlaviyo('Newsletter Popup Subscribed');

          formView.hidden = true;

          if (genderView) {
            genderView.hidden = false;

            const firstChoice = genderView.querySelector('[data-noyoco-popup-gender-choice]');
            if (firstChoice) firstChoice.focus();
          } else {
            showSuccess();
          }
        } catch (error) {
          errorMessage.textContent = popup.dataset.errorMessage;
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.defaultLabel;
        }
      });

      if (forceOpen) {
        window.setTimeout(openPopup, 120);
        return;
      }

      const views = readStoredNumber(viewKey) + 1;
      writeStoredNumber(viewKey, views);

      if (views >= 2) engaged = true;

      const delay = window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 750 ? 10000 : 8000;

      triggerTimer = window.setTimeout(() => {
        delayPassed = true;
        maybeOpen();
      }, delay);

      window.addEventListener('scroll', handleEngagement, { passive: true });
      document.addEventListener('mouseout', handleExitIntent);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePopup, { once: true });
    } else {
      initializePopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-restock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noyoco-restock')) {
    class NoyocoRestock extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.root = this.closest('kercambre-product');
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.email = this.form.elements.email;
        this.optin = this.form.elements.marketing_optin;
        this.submitButton = this.form.querySelector('[type=submit]');
        this.status = this.querySelector('[data-restock-status]');
        this.productLink = this.querySelector('[data-restock-product-link]');
        this.variantLabel = this.querySelector('[data-restock-variant]');
        this.abort = new AbortController();
        const options = { signal:this.abort.signal };
        document.addEventListener('noyoco:variant-change', () => this.sync(), options);
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-restock-open]');
          if (trigger) { event.preventDefault(); this.open(trigger); }
        }, options);
        this.querySelector('[data-restock-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        } }, options);
        this.dialog.addEventListener('close', () => { if (this.opener?.isConnected) this.opener.focus(); }, options);
        this.form.addEventListener('submit', event => { event.preventDefault(); this.subscribe(); }, options);
        customElements.whenDefined('kercambre-product').then(() => {
          if (!this.isConnected) return;
          const variant = this.root?.product?.currentVariant;
          if (variant && this.root.product.variants.length === 1) this.root.dataset.sizeExplicit = 'true';
          this.sync();
        });
        window.addEventListener('load', () => this.sync(), { ...options, once:true });
      }
      disconnectedCallback() { this.abort?.abort(); this.initialised = false; }
      sync() {
        const variant = this.root?.product?.currentVariant;
        if (!variant) return;
        this.current = variant;
        const explicit = this.root.dataset.sizeExplicit === 'true' || this.root.product.variants.length === 1;
        const restock = explicit && !variant.available;
        this.root.dataset.restockMode = String(restock);
        document.body.dataset.restockMode = String(restock);
        document.querySelectorAll('[data-restock-open]').forEach(button => { button.hidden = !restock; });
        const main = document.getElementById('main-atc');
        if (!explicit && main) {
          main.removeAttribute('disabled');
          main.classList.remove('disabled', 'out-of-stock', 'pointer-events-none');
        }
        if (explicit) {
          this.root.querySelectorAll('.noyoco-size-choice__input').forEach(input => { input.checked = String(input.value) === String(variant.id); });
          this.root.querySelectorAll('[data-size-status]').forEach(label => { label.textContent = variant.title; });
        }
      }
      open(trigger) {
        if (this.busy) return;
        this.sync();
        if (!this.current || this.current.available || this.root.dataset.restockMode !== 'true') return;
        this.requestedVariant = { id:String(this.current.id), title:this.current.title };
        this.opener = trigger;
        this.variantLabel.textContent = this.current.title === 'Default Title' ? '' : this.current.title;
        this.productLink.href = this.dataset.productUrl + '?variant=' + encodeURIComponent(this.requestedVariant.id);
        this.status.hidden = true;
        this.productLink.hidden = true;
        this.form.hidden = false;
        if (this.optin) this.optin.checked = false;
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.dataset.submit;
        this.dialog.showModal();
        this.email.focus();
      }
      async subscribe() {
        if (this.busy || !this.form.reportValidity() || !this.requestedVariant) return;
        this.busy = true;
        const variantId = this.requestedVariant.id;
        const email = this.email.value.trim();
        const wantsMarketing = this.optin ? this.optin.checked === true : false;
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.dataset.pending;
        this.status.hidden = true;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          // Recheck Shopify before sending an alert request for a stale page.
          const stock = await fetch(this.dataset.productUrl + '.js', { credentials:'same-origin', cache:'no-store', signal:controller.signal });
          if (!stock.ok) throw new Error('stock_unavailable');
          const product = await stock.json();
          const variant = product.variants.find(item => String(item.id) === variantId);
          if (!variant) throw new Error('variant_missing');
          if (variant.available) {
            this.form.hidden = true;
            this.productLink.hidden = false;
            this.showStatus(this.dataset.available, false);
            return;
          }
          const locale = (this.dataset.locale || '').toLowerCase().split(/[-_]/)[0];
          if (locale === 'fr' || locale === 'en') {
            const languageResponse = await fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(this.dataset.company), {
              method:'POST', headers:{ 'Content-Type':'application/json', revision:'2026-07-15' }, signal:controller.signal,
              body:JSON.stringify({ data:{ type:'profile', attributes:{ email, properties:{ noyoco_restock_locale:locale, noyoco_restock_locale_source:'restock_form' } } } })
            });
            if (languageResponse.status !== 202) throw new Error('language_update_failed');
          }
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
            method:'POST', headers:{ 'Content-Type':'application/json', revision:'2026-07-15' }, signal:controller.signal,
            body:JSON.stringify({ data:{ type:'back-in-stock-subscription', attributes:{ profile:{ data:{ type:'profile', attributes:{ email } } }, channels:['EMAIL'] }, relationships:{ variant:{ data:{ type:'catalog-variant', id:'$shopify:::$default:::' + variantId } } } } })
          });
          if (response.status !== 202) {
            console.error('[noyoco-restock] back-in-stock refused', { status:response.status });
            throw new Error('subscription_failed');
          }
          const marketingSaved = wantsMarketing ? await this.subscribeMarketing(email) : false;
          this.form.hidden = true;
          this.email.value = '';
          this.showStatus(wantsMarketing ? (marketingSaved ? this.dataset.marketingSuccess : this.dataset.marketingError) : this.dataset.success, wantsMarketing && !marketingSaved);
        } catch (error) {
          console.error('[noyoco-restock] request failed', { reason:error?.message || error, variantId });
          this.showStatus(this.dataset.error, true);
        } finally {
          clearTimeout(timer); this.busy = false; this.submitButton.disabled = false; this.submitButton.textContent = this.dataset.submit;
        }
      }
      // Marketing opt-in is a separate, explicit request. It must never break the alert.
      async subscribeMarketing(email) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
            method:'POST', signal:controller.signal, headers:{ 'Content-Type':'application/json', revision:'2026-07-15' },
            body:JSON.stringify({ data:{ type:'subscription',
              attributes:{ custom_source:this.dataset.optinSource,
                profile:{ data:{ type:'profile', attributes:{ email,
                  properties:{ noyoco_newsletter_signup_locale:this.dataset.locale },
                  subscriptions:{ email:{ marketing:{ consent:'SUBSCRIBED' } } } } } } },
              relationships:{ list:{ data:{ type:'list', id:this.dataset.list } } } } })
          });
          if (response.status !== 202) {
            console.error('[noyoco-restock] marketing opt-in refused', { status:response.status });
          }
          return response.status === 202;
        } catch (error) {
          console.error('[noyoco-restock] marketing opt-in failed', { reason:error?.message || error });
          return false;
        } finally { clearTimeout(timer); }
      }
      showStatus(text, error) { this.status.textContent = text; this.status.dataset.error = String(error); this.status.hidden = false; }
    }
    customElements.define('noyoco-restock', NoyocoRestock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noyoco-supply-route-map"] && !Shopify.designMode) return;
  try {
    (() => {
    const namespace = 'http://www.w3.org/2000/svg';
    const coordinates = {
      'bulgarie|sliven': [42.6817, 26.3229],
      'ecosse|dundee': [56.462, -2.9707],
      'ecosse|kinross': [56.2047, -3.4214],
      'espagne|alicante': [38.3452, -0.481],
      'espagne|banyeres de mariola': [38.715, -0.658],
      'espagne|barcelone': [41.3874, 2.1686],
      'espagne|cabezon de la sal': [43.308, -4.236],
      'espagne|satander': [43.4623, -3.81],
      'espagne|santander': [43.4623, -3.81],
      'espagne|terrassa': [41.5632, 2.0089],
      'france|couzon-au-mont-dor': [45.8448, 4.8287],
      'france|paris': [48.8566, 2.3522],
      'grece|athenes': [37.9838, 23.7275],
      'grece|metamorfosi': [38.0658, 23.7636],
      'grece|nea filadelfeia': [38.0401, 23.7451],
      'italie|adro': [45.6206, 9.9616],
      'italie|agliana': [43.9025, 11.0053],
      'italie|albino': [45.7637, 9.8015],
      'italie|biella': [45.5629, 8.0583],
      'italie|bra': [44.6978, 7.8556],
      'italie|calenzano': [43.8545, 11.1661],
      'italie|gaggio montano': [44.195, 10.935],
      'italie|gallarate': [45.6602, 8.7934],
      'italie|montemurlo': [43.9267, 11.0378],
      'italie|montirone': [45.4461, 10.2282],
      'italie|olmeda di capiago': [45.7682, 9.1276],
      'italie|orsenigo': [45.7787, 9.1796],
      'italie|palazzolo sulloglio': [45.5968, 9.8867],
      'italie|piancogno': [45.9206, 10.2261],
      'italie|piove di sacco': [45.2967, 12.0364],
      'italie|prato': [43.8777, 11.1022],
      'italie|pratrivero': [45.673, 8.045],
      'italie|robecchetto con induno': [45.529, 8.765],
      'italie|tollegno': [45.5902, 8.0508],
      'italie|valdilana': [45.6264, 8.1518],
      'italie|valle mosso': [45.633, 8.143],
      'italie|vaprio dadda': [45.5764, 9.5325],
      'pays-bas|nieuwegein': [52.0292, 5.0806],
      'pays-bas|beringe': [51.3368, 5.9483],
      'pologne|lodz': [51.7592, 19.456],
      'portugal|barcelos': [41.5388, -8.615],
      'portugal|castanheira de pera': [40.002, -8.2107],
      'portugal|covilha': [40.2807, -7.5041],
      'portugal|famalicao': [41.4079, -8.5196],
      'portugal|guimaraes': [41.4425, -8.2918],
      'portugal|maia': [41.2357, -8.6199],
      'portugal|ribeirao': [41.36, -8.567],
      'portugal|ronfe': [41.441, -8.382],
      'portugal|tortosendo': [40.2383, -7.5225],
      'portugal|vila nova de famalicao': [41.4111, -8.5237],
      'portugal|vilarinho das cambas': [41.407, -8.555],
      'republique tcheque|horice': [50.3661, 15.6318],
      'republique tcheque|letohrad': [50.0358, 16.4988],
      'roumanie|bacau': [46.567, 26.9146],
      'roumanie|baicoi': [45.033, 25.85],
      'roumanie|bragadiru': [44.3711, 25.9775],
      'roumanie|bucarest': [44.4268, 26.1025],
      'roumanie|bucuresti': [44.4268, 26.1025],
      'roumanie|buftea': [44.5728, 25.9384],
      'roumanie|dragomiresti-deal': [44.4621, 25.938],
      'roumanie|giurgiu': [43.9037, 25.9699],
      'roumanie|iasi': [47.1585, 27.6014],
      'roumanie|jilava': [44.3333, 26.0781],
      'roumanie|moreni': [44.983, 25.6442],
      'roumanie|oltenita': [44.0864, 26.6364],
      'roumanie|ploiesti': [44.936, 26.013],
      'roumanie|racova': [46.7029, 26.7411],
      'roumanie|ramnicu valcea': [45.0997, 24.3693],
      'roumanie|voluntari': [44.49, 26.18],
      'turquie|aydin': [37.845, 27.8396],
      'turquie|bursa': [40.195, 29.06],
      'turquie|denizli': [37.7765, 29.0864],
      'turquie|istanbul': [41.0082, 28.9784],
      'chine|guangzhou': [23.1291, 113.2644],
      'chine|shaoxing': [30.0024, 120.5811],
      'pakistan|lahore': [31.5204, 74.3587],
      'argentine|*': [-38.4161, -63.6167],
      'australie|*': [-25.2744, 133.7751],
      'autriche|*': [47.5162, 14.5501],
      'bangladesh|*': [23.685, 90.3563],
      'bulgarie|*': [42.7339, 25.4858],
      'chine|*': [35.8617, 104.1954],
      'ecosse|*': [56.4907, -4.2026],
      'espagne|*': [40.4637, -3.7492],
      'grece|*': [39.0742, 21.8243],
      'inde|*': [20.5937, 78.9629],
      'italie|*': [42.8333, 12.8333],
      'japon|*': [36.2048, 138.2529],
      'kirghizistan|*': [41.2044, 74.7661],
      'mongolie|*': [46.8625, 103.8467],
      'nouvelle-zelande|*': [-40.9006, 174.886],
      'pakistan|*': [30.3753, 69.3451],
      'pologne|*': [51.9194, 19.1451],
      'portugal|*': [39.3999, -8.2245],
      'republique tcheque|*': [49.8175, 15.473],
      'roumanie|*': [45.9432, 24.9668],
      'royaume-uni|*': [55.3781, -3.436],
      'tadjikistan|*': [38.861, 71.2761],
      'tanzanie|*': [-6.369, 34.8888],
      'turquie|*': [38.9637, 35.2433],
      'uruguay|*': [-32.5228, -55.7658]
    };

    const clean = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const frame = { width: 1000, height: 720, minLat: 33, maxLat: 55, minLon: -11, maxLon: 31, padding: 25 };
    const categoryPriority = {
      fabric: 10,
      lining: 30,
      interfacing: 35,
      wadding: 40,
      padding: 40,
      button: 50,
      zip: 50,
      elastic: 50,
      trimmings: 50,
      magnet: 50,
      jacron: 50,
      cord: 50,
      buckle: 50,
      'cord-stopper': 50,
      ring: 50,
      hook: 50,
      thread: 60,
      label: 70,
      packaging: 90
    };
    const europeanCountries = new Set([
      'albanie', 'albania', 'allemagne', 'germany', 'autriche', 'austria', 'belgique', 'belgium',
      'bosnie-herzegovine', 'bosnia and herzegovina', 'bulgarie', 'bulgaria', 'chypre', 'cyprus',
      'croatie', 'croatia', 'danemark', 'denmark', 'ecosse', 'scotland', 'espagne', 'spain',
      'estonie', 'estonia', 'finlande', 'finland', 'france', 'grece', 'greece', 'hongrie', 'hungary',
      'irlande', 'ireland', 'islande', 'iceland', 'italie', 'italy', 'kosovo', 'lettonie', 'latvia',
      'lituanie', 'lithuania', 'luxembourg', 'macedoine du nord', 'north macedonia', 'malte', 'malta',
      'moldavie', 'moldova', 'montenegro', 'norvege', 'norway', 'pays-bas', 'netherlands',
      'pologne', 'poland', 'portugal', 'republique tcheque', 'czech republic', 'tchequie', 'czechia',
      'roumanie', 'romania', 'royaume-uni', 'united kingdom', 'serbie', 'serbia', 'slovaquie', 'slovakia',
      'slovenie', 'slovenia', 'suede', 'sweden', 'suisse', 'switzerland', 'turquie', 'turkey',
      'ukraine'
    ]);
    const project = (lat, lon) => ({
      x: ((lon - frame.minLon) / (frame.maxLon - frame.minLon)) * frame.width,
      y: ((frame.maxLat - lat) / (frame.maxLat - frame.minLat)) * frame.height
    });

    const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

    const distanceInKilometres = (from, to) => {
      const toRadians = (degrees) => degrees * (Math.PI / 180);
      const latitudeDelta = toRadians(to.lat - from.lat);
      const longitudeDelta = toRadians(to.lon - from.lon);
      const fromLatitude = toRadians(from.lat);
      const toLatitude = toRadians(to.lat);
      const haversine = Math.sin(latitudeDelta / 2) ** 2 +
        (Math.cos(fromLatitude) * Math.cos(toLatitude) * Math.sin(longitudeDelta / 2) ** 2);
      return 6371 * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
    };

    const formatDistance = (map, distance) => {
      const roundedDistance = Math.max(50, Math.round(distance / 50) * 50);
      const locale = document.documentElement.lang || 'fr-FR';
      return '≈ ' + new Intl.NumberFormat(locale).format(roundedDistance) + ' ' + map.dataset.kilometresLabel;
    };

    const pointCoordinates = (element) => {
      const suppliedLat = Number.parseFloat(element.dataset.lat);
      const suppliedLon = Number.parseFloat(element.dataset.lon);
      if (Number.isFinite(suppliedLat) && Number.isFinite(suppliedLon)) {
        return { lat: suppliedLat, lon: suppliedLon, approximate: false };
      }

      const country = clean(element.dataset.country);
      const city = clean(element.dataset.city);
      const exact = coordinates[country + '|' + city];
      if (exact) return { lat: exact[0], lon: exact[1], approximate: false };

      const countryCentre = coordinates[country + '|*'];
      return countryCentre ? { lat: countryCentre[0], lon: countryCentre[1], approximate: true } : null;
    };

    const createSvg = (name, attributes = {}) => {
      const element = document.createElementNS(namespace, name);
      Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, String(value)));
      return element;
    };

    const routePath = (from, to, lane, routeIndex) => {
      const dx = to.x - from.x;
      const dy = to.y - from.y;
      const distance = Math.sqrt((dx * dx) + (dy * dy));
      const baseBend = Math.min(54, Math.max(14, distance * 0.09));
      const direction = lane === 0 ? (routeIndex % 2 === 0 ? 1 : -1) : Math.sign(lane);
      const bend = direction * (baseBend + (Math.abs(lane) * 5));
      const midpointX = (from.x + to.x) / 2;
      const midpointY = (from.y + to.y) / 2;
      const controlX = midpointX - ((dy / Math.max(distance, 1)) * bend);
      const controlY = midpointY + ((dx / Math.max(distance, 1)) * bend);
      return 'M' + from.x.toFixed(1) + ',' + from.y.toFixed(1) +
        ' Q' + controlX.toFixed(1) + ',' + controlY.toFixed(1) +
        ' ' + to.x.toFixed(1) + ',' + to.y.toFixed(1);
    };

    const appendStatus = (element, label, className) => {
      element.classList.add(className);
      element.dataset.mapStatus = label;
      const detail = element.querySelector('small');
      if (detail && label) detail.append(document.createTextNode(' · ' + label));
    };

    const unique = (values) => [...new Set(values.filter(Boolean))];

    const placeLabel = (point) => [point.city, point.country].filter(Boolean).join(', ');

    const componentLabelsForPoint = (element) => {
      if (element.dataset.componentLabel) return [element.dataset.componentLabel];
      const componentList = element.querySelector('.noyoco-route-map__components');
      if (!componentList) return [];
      return componentList.textContent
        .split('·')
        .map((label) => label.trim())
        .filter(Boolean);
    };

    const initialize = (map) => {
      if (map.dataset.initialized === 'true') return;

      const ledgerList = map.querySelector('.noyoco-route-map__list');
      if (ledgerList) {
        Array.from(ledgerList.children)
          .map((element, index) => ({ element, index }))
          .sort((left, right) => {
            const orderDifference = Number(left.element.dataset.mapOrder || 80) - Number(right.element.dataset.mapOrder || 80);
            return orderDifference || left.index - right.index;
          })
          .forEach(({ element }) => ledgerList.appendChild(element));
      }

      const svg = map.querySelector('[data-map-svg]');
      const anchorsLayer = map.querySelector('[data-map-anchors]');
      const routesLayer = map.querySelector('[data-map-routes]');
      const nodesLayer = map.querySelector('[data-map-nodes]');
      const pointElements = Array.from(map.querySelectorAll('[data-map-point]'));
      const flowElements = Array.from(map.querySelectorAll('[data-map-flow]')).sort((left, right) => {
        const leftCategory = clean(left.dataset.category).replace(/[^a-z0-9]+/g, '-');
        const rightCategory = clean(right.dataset.category).replace(/[^a-z0-9]+/g, '-');
        return (categoryPriority[leftCategory] || 80) - (categoryPriority[rightCategory] || 80);
      });
      if (!svg || !anchorsLayer || !routesLayer || !nodesLayer || pointElements.length === 0) return;

      const inspector = map.querySelector('[data-map-inspector]');
      const interactionHint = map.querySelector('[data-map-interaction-hint]');
      const inspectorClose = map.querySelector('[data-map-inspector-close]');
      const inspectorContent = {
        kicker: map.querySelector('[data-map-inspector-kicker]'),
        title: map.querySelector('[data-map-inspector-title]'),
        route: map.querySelector('[data-map-inspector-route]'),
        component: map.querySelector('[data-map-inspector-component]'),
        supplier: map.querySelector('[data-map-inspector-supplier]'),
        distance: map.querySelector('[data-map-inspector-distance]'),
        date: map.querySelector('[data-map-inspector-date]')
      };
      let activeControl = null;
      let activeVisual = null;

      const hideInspector = (restoreFocus = false) => {
        if (activeControl) activeControl.setAttribute('aria-expanded', 'false');
        if (activeVisual) activeVisual.classList.remove('is-selected');
        if (inspector) inspector.hidden = true;
        if (interactionHint) interactionHint.hidden = false;
        if (restoreFocus && activeControl && typeof activeControl.focus === 'function') activeControl.focus();
        activeControl = null;
        activeVisual = null;
      };

      const setInspectorField = (name, value) => {
        const output = inspectorContent[name];
        const row = inspector?.querySelector('[data-map-inspector-field="' + name + '"]');
        if (!output || !row) return;
        row.hidden = !value;
        output.textContent = value || '';
      };

      const showInspector = (control, visual, details) => {
        if (!inspector) return;
        if (activeControl && activeControl !== control) activeControl.setAttribute('aria-expanded', 'false');
        if (activeVisual && activeVisual !== visual) activeVisual.classList.remove('is-selected');

        activeControl = control;
        activeVisual = visual;
        control.setAttribute('aria-expanded', 'true');
        visual.classList.add('is-selected');
        inspectorContent.kicker.textContent = details.kicker || map.dataset.inspectorPointLabel;
        inspectorContent.title.textContent = details.title || details.component;
        inspectorContent.route.textContent = details.from && details.to
          ? details.from + ' → ' + details.to
          : details.from || details.to || '';
        setInspectorField('component', details.component);
        setInspectorField('supplier', details.supplier);
        setInspectorField('distance', details.distance);
        setInspectorField('date', details.date || map.dataset.inspectorDateUnavailable);
        inspector.hidden = false;
        if (interactionHint) interactionHint.hidden = true;
      };

      const bindInteraction = (control, visual, details) => {
        control.setAttribute('tabindex', '0');
        control.setAttribute('role', 'button');
        control.setAttribute('aria-expanded', 'false');
        control.setAttribute(
          'aria-label',
          [details.kicker, details.title, details.from && details.to ? details.from + ' → ' + details.to : '', details.distance]
            .filter(Boolean)
            .join(' — ')
        );
        const activate = (event) => {
          event.stopPropagation();
          showInspector(control, visual, details);
        };
        control.addEventListener('click', activate);
        control.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activate(event);
        });
      };

      inspectorClose?.addEventListener('click', () => hideInspector(true));
      map.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && inspector && !inspector.hidden) hideInspector(true);
      });

      const nodesById = new Map();
      pointElements.forEach((element) => {
        const coordinatesForPoint = pointCoordinates(element);
        if (!coordinatesForPoint) {
          appendStatus(element, map.dataset.unlocatedLabel, 'noyoco-route-map__item--unlocated');
          return;
        }

        const defaultKey = element.dataset.kind + '|' + clean(element.dataset.country) + '|' + clean(element.dataset.city);
        const id = element.dataset.nodeKey || defaultKey;
        const rawPosition = project(coordinatesForPoint.lat, coordinatesForPoint.lon);
        const isOutside = coordinatesForPoint.lon < frame.minLon || coordinatesForPoint.lon > frame.maxLon ||
          coordinatesForPoint.lat < frame.minLat || coordinatesForPoint.lat > frame.maxLat;
        const position = isOutside ? {
          x: clamp(rawPosition.x, frame.padding, frame.width - frame.padding),
          y: clamp(rawPosition.y, frame.padding, frame.height - frame.padding)
        } : rawPosition;

        if (isOutside) {
          appendStatus(element, map.dataset.offMapLabel, 'noyoco-route-map__item--off-map');
        } else if (coordinatesForPoint.approximate) {
          appendStatus(element, map.dataset.countryOnlyLabel, 'noyoco-route-map__item--country-only');
        }

        const existing = nodesById.get(id);
        if (existing) {
          existing.elements.push(element);
          existing.isOutside = existing.isOutside || isOutside;
          existing.isApproximate = existing.isApproximate || coordinatesForPoint.approximate;
        } else {
          nodesById.set(id, {
            id,
            city: element.dataset.city,
            country: element.dataset.country,
            kind: element.dataset.kind,
            anchorPosition: { ...position },
            position,
            lat: coordinatesForPoint.lat,
            lon: coordinatesForPoint.lon,
            elements: [element],
            flowCount: 0,
            isOutside,
            isApproximate: coordinatesForPoint.approximate
          });
        }
      });

      const priority = { material: 1, supply: 2, destination: 3, assembly: 4 };
      const nodes = Array.from(nodesById.values());
      nodes.forEach((node) => {
        node.elements.forEach((element) => {
          if ((priority[element.dataset.kind] || 0) > (priority[node.kind] || 0)) {
            node.kind = element.dataset.kind;
          }
        });
      });

      const assembly = nodes.find((node) => node.kind === 'assembly');
      const destination = nodes.find((node) => node.kind === 'destination');
      if (!assembly || !destination) {
        map.classList.add('noyoco-route-map--list-only');
        map.dataset.initialized = 'true';
        return;
      }

      const supplyNodes = nodes.filter((node) => node.kind === 'supply');
      const directSupplierGroups = new Map();
      pointElements
        .filter((element) => element.dataset.kind === 'supply')
        .forEach((element) => {
          const key = element.dataset.nodeKey ||
            clean(element.dataset.label) + '|' + clean(element.dataset.country) + '|' + clean(element.dataset.city);
          if (!directSupplierGroups.has(key)) directSupplierGroups.set(key, element);
        });
      const directSuppliers = Array.from(directSupplierGroups.values());
      const europeanDirectSuppliers = directSuppliers.filter((element) => europeanCountries.has(clean(element.dataset.country)));
      const directEuropeValue = map.querySelector('[data-map-direct-europe]');
      const directEuropeFact = map.querySelector('[data-map-fact="direct-europe"]');
      if (directEuropeValue && directSuppliers.length > 0) {
        directEuropeValue.textContent = europeanDirectSuppliers.length + '/' + directSuppliers.length;
      } else if (directEuropeFact) {
        directEuropeFact.hidden = true;
      }

      const finalDistanceValue = map.querySelector('[data-map-final-distance]');
      const finalDistanceFact = map.querySelector('[data-map-fact="final-distance"]');
      if (finalDistanceValue) {
        finalDistanceValue.textContent = formatDistance(map, distanceInKilometres(assembly, destination));
      } else if (finalDistanceFact) {
        finalDistanceFact.hidden = true;
      }

      const fabricSource = supplyNodes.find((node) =>
        node.elements.some((element) => clean(element.dataset.category) === 'fabric')
      );
      const fabricDistanceValue = map.querySelector('[data-map-fabric-distance]');
      const fabricDistanceFact = map.querySelector('[data-map-fact="fabric-distance"]');
      if (fabricSource && fabricDistanceValue) {
        const fabricDistance = distanceInKilometres(fabricSource, assembly) + distanceInKilometres(assembly, destination);
        fabricDistanceValue.textContent = formatDistance(map, fabricDistance);
      } else if (fabricDistanceFact) {
        fabricDistanceFact.hidden = true;
      }

      const flowsByNode = new Map();
      flowElements.forEach((flow) => {
        const key = flow.dataset.nodeKey;
        if (!flowsByNode.has(key)) flowsByNode.set(key, []);
        flowsByNode.get(key).push(flow);
      });
      flowsByNode.forEach((flows, key) => {
        const node = nodesById.get(key);
        if (node) node.flowCount = flows.length;
      });

      const sources = nodes.filter((node) => node !== assembly && node !== destination);
      const placed = [assembly, destination];
      sources.forEach((source) => {
        const origin = { ...source.anchorPosition };
        let candidate = origin;
        let attempt = 0;
        const overlaps = () => placed.some((point) => {
          const dx = point.position.x - candidate.x;
          const dy = point.position.y - candidate.y;
          return Math.sqrt((dx * dx) + (dy * dy)) < 27;
        });

        while (overlaps() && attempt < 24) {
          attempt += 1;
          const angle = attempt * 2.39996;
          const radius = 15 + (Math.floor((attempt - 1) / 6) * 8);
          candidate = {
            x: clamp(origin.x + (Math.cos(angle) * radius), frame.padding, frame.width - frame.padding),
            y: clamp(origin.y + (Math.sin(angle) * radius), frame.padding, frame.height - frame.padding)
          };
        }

        source.position = candidate;
        placed.push(source);

        const shiftX = source.position.x - source.anchorPosition.x;
        const shiftY = source.position.y - source.anchorPosition.y;
        if (Math.sqrt((shiftX * shiftX) + (shiftY * shiftY)) > 3) {
          anchorsLayer.appendChild(createSvg('line', {
            class: 'noyoco-route-map__tether',
            x1: source.anchorPosition.x.toFixed(1),
            y1: source.anchorPosition.y.toFixed(1),
            x2: source.position.x.toFixed(1),
            y2: source.position.y.toFixed(1)
          }));
          anchorsLayer.appendChild(createSvg('circle', {
            class: 'noyoco-route-map__anchor-point',
            cx: source.anchorPosition.x.toFixed(1),
            cy: source.anchorPosition.y.toFixed(1),
            r: 1.8
          }));
        }
      });

      const createInteractiveRoute = ({
        pathData,
        className,
        routeIndex,
        details,
        haloClass,
        markerEnd
      }) => {
        const group = createSvg('g', { class: 'noyoco-route-map__route-group' });
        if (haloClass) {
          group.appendChild(createSvg('path', {
            d: pathData,
            class: 'noyoco-route-map__route ' + haloClass,
            style: '--route-index:' + routeIndex
          }));
        }

        const routeAttributes = {
          d: pathData,
          class: 'noyoco-route-map__route ' + className,
          style: '--route-index:' + routeIndex
        };
        if (markerEnd) routeAttributes['marker-end'] = markerEnd;
        group.appendChild(createSvg('path', routeAttributes));

        const hitArea = createSvg('path', {
          d: pathData,
          class: 'noyoco-route-map__route-hit'
        });
        group.appendChild(hitArea);
        routesLayer.appendChild(group);
        bindInteraction(hitArea, group, details);
        return group;
      };

      let routeIndex = 0;
      flowsByNode.forEach((flows, nodeKey) => {
        const source = nodesById.get(nodeKey);
        if (!source) return;

        flows.forEach((flow, flowIndex) => {
          const lane = flowIndex - ((flows.length - 1) / 2);
          const category = clean(flow.dataset.category).replace(/[^a-z0-9]+/g, '-');
          const routeState = source.isOutside ? ' noyoco-route-map__route--off-map' :
            source.isApproximate ? ' noyoco-route-map__route--approximate' : '';
          const flowNumber = String(flow.dataset.order || routeIndex + 1).padStart(2, '0');
          const details = {
            kicker: map.dataset.inspectorFlowLabel + ' ' + flowNumber,
            title: flow.dataset.componentLabel || flow.dataset.categoryLabel,
            component: flow.dataset.componentLabel || flow.dataset.categoryLabel,
            supplier: flow.dataset.supplier || map.dataset.inspectorSupplierUnknown,
            from: placeLabel(source),
            to: placeLabel(assembly),
            distance: formatDistance(map, distanceInKilometres(source, assembly)),
            date: flow.dataset.date || map.dataset.productionDate
          };
          createInteractiveRoute({
            pathData: routePath(source.position, assembly.position, lane, routeIndex),
            className: 'noyoco-route-map__route--supply noyoco-route-map__route--supply-' + category + routeState,
            routeIndex,
            details
          });
          routeIndex += 1;
        });
      });

      const materialElements = pointElements.filter((element) => element.dataset.kind === 'material');
      const materialByNode = new Map();
      materialElements.forEach((element) => {
        const key = element.dataset.nodeKey ||
          'material|' + clean(element.dataset.country) + '|' + clean(element.dataset.city);
        if (!materialByNode.has(key)) materialByNode.set(key, []);
        materialByNode.get(key).push(element);
      });
      materialByNode.forEach((elements, nodeKey) => {
        const source = nodesById.get(nodeKey);
        if (!source) return;
        elements.forEach((element, elementIndex) => {
          const lane = elementIndex - ((elements.length - 1) / 2);
          const routeState = source.isOutside ? ' noyoco-route-map__route--off-map' :
            source.isApproximate ? ' noyoco-route-map__route--approximate' : '';
          const details = {
            kicker: map.dataset.inspectorFlowLabel,
            title: element.dataset.stepLabel || element.dataset.label,
            component: element.dataset.componentLabel || element.dataset.label,
            supplier: element.dataset.supplier || map.dataset.inspectorSupplierUnknown,
            from: placeLabel(source),
            to: placeLabel(assembly),
            distance: formatDistance(map, distanceInKilometres(source, assembly)),
            date: element.dataset.date || map.dataset.productionDate
          };
          createInteractiveRoute({
            pathData: routePath(source.position, assembly.position, lane, routeIndex),
            className: 'noyoco-route-map__route--material' + routeState,
            routeIndex,
            details
          });
          routeIndex += 1;
        });
      });

      const finalPath = routePath(assembly.position, destination.position, 0, routeIndex);
      const assemblyElement = assembly.elements[0];
      createInteractiveRoute({
        pathData: finalPath,
        className: 'noyoco-route-map__route--final',
        haloClass: 'noyoco-route-map__route--final-halo',
        markerEnd: 'url(#' + svg.dataset.arrowId + ')',
        routeIndex,
        details: {
          kicker: map.dataset.inspectorFinalLabel,
          title: assemblyElement.dataset.componentLabel || map.dataset.inspectorFinalLabel,
          component: assemblyElement.dataset.componentLabel,
          supplier: assemblyElement.dataset.supplier || assemblyElement.dataset.label,
          from: placeLabel(assembly),
          to: placeLabel(destination),
          distance: formatDistance(map, distanceInKilometres(assembly, destination)),
          date: assemblyElement.dataset.date || map.dataset.productionDate
        }
      });

      let sourceIndex = 0;
      nodes.forEach((node) => {
        let markerLabel;
        if (node === assembly) markerLabel = 'A';
        else if (node === destination) markerLabel = 'P';
        else {
          sourceIndex += 1;
          markerLabel = String(sourceIndex).padStart(2, '0');
        }

        node.elements.forEach((element) => {
          const reference = element.querySelector('[data-map-reference]');
          if (reference) reference.textContent = markerLabel;
        });

        const marker = createSvg('g', {
          class: 'noyoco-route-map__node noyoco-route-map__node--' + node.kind +
            (node.isOutside ? ' noyoco-route-map__node--off-map' : '') +
            (node.isApproximate ? ' noyoco-route-map__node--approximate' : ''),
          transform: 'translate(' + node.position.x.toFixed(1) + ' ' + node.position.y.toFixed(1) + ')'
        });
        const labels = [...new Set(node.elements.map((element) => element.dataset.label).filter(Boolean))];
        const title = createSvg('title');
        title.textContent = [labels.join(' · '), node.city + ', ' + node.country, node.flowCount || '']
          .filter(Boolean)
          .join(' — ');
        marker.appendChild(title);

        const radius = node === assembly || node === destination
          ? 13
          : Math.min(12, 8.5 + Math.sqrt(Math.max(node.flowCount, 1)));
        if (node.flowCount > 1 || node.isOutside || node.isApproximate) {
          marker.appendChild(createSvg('circle', {
            class: 'noyoco-route-map__node-ring',
            r: radius + 3
          }));
        }
        marker.appendChild(createSvg('circle', {
          class: 'noyoco-route-map__node-core',
          r: radius
        }));

        const markerText = createSvg('text', {
          'text-anchor': 'middle',
          y: '3.3'
        });
        markerText.textContent = markerLabel;
        marker.appendChild(markerText);

        const isFabricSource = node.elements.some((element) => clean(element.dataset.category) === 'fabric');
        if (node === assembly || node === destination || node.isOutside || isFabricSource) {
          const label = createSvg('text', {
            class: 'noyoco-route-map__node-label',
            x: node.position.x > 700 ? -19 : 19,
            y: -17,
            'text-anchor': node.position.x > 700 ? 'end' : 'start'
          });
          label.textContent = node === destination ? 'PARIS' :
            node.isOutside && node !== assembly ? node.country : node.city.toUpperCase();
          marker.appendChild(label);
        }

        const nodeFlows = flowsByNode.get(node.id) || [];
        const nodeComponents = unique([
          ...nodeFlows.map((flow) => flow.dataset.componentLabel || flow.dataset.categoryLabel),
          ...node.elements.flatMap(componentLabelsForPoint)
        ]);
        const nodeSuppliers = unique([
          ...nodeFlows.map((flow) => flow.dataset.supplier),
          ...node.elements.map((element) => element.dataset.supplier)
        ]);
        const stepLabels = unique(node.elements.map((element) => element.dataset.stepLabel));
        let routeFrom = placeLabel(node);
        let routeTo = placeLabel(assembly);
        let routeDistance = formatDistance(map, distanceInKilometres(node, assembly));
        if (node === assembly || node === destination) {
          routeFrom = placeLabel(assembly);
          routeTo = placeLabel(destination);
          routeDistance = formatDistance(map, distanceInKilometres(assembly, destination));
        }

        const nodeDetails = {
          kicker: map.dataset.inspectorPointLabel + ' ' + markerLabel,
          title: node === destination
            ? node.elements[0].dataset.label
            : nodeSuppliers.join(' · ') || stepLabels.join(' · ') || labels.join(' · '),
          component: nodeComponents.join(' · '),
          supplier: nodeSuppliers.join(' · ') || (
            node === destination
              ? assemblyElement.dataset.supplier || assemblyElement.dataset.label
              : map.dataset.inspectorSupplierUnknown
          ),
          from: routeFrom,
          to: routeTo,
          distance: routeDistance,
          date: unique([
            ...nodeFlows.map((flow) => flow.dataset.date),
            ...node.elements.map((element) => element.dataset.date),
            map.dataset.productionDate
          ])[0]
        };
        bindInteraction(marker, marker, nodeDetails);
        node.elements.forEach((element) => bindInteraction(element, marker, nodeDetails));
        nodesLayer.appendChild(marker);
      });

      map.dataset.initialized = 'true';
      requestAnimationFrame(() => map.classList.add('is-ready'));
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-noyoco-route-map]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noyoco-size-choice')) {
    class NoyocoSizeChoice extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-size-trigger]');
        this.panel = this.querySelector('[data-size-panel]');
        this.statuses = Array.from(this.querySelectorAll('[data-size-status]'));
        this.inputs = Array.from(this.querySelectorAll('.noyoco-size-choice__input'));
        this.chooseLabel = this.dataset.chooseLabel;
        this.addLabel = this.dataset.addLabel;
        this.desktopQuery = window.matchMedia('(min-width: 768px)');

        this.trigger.addEventListener('click', () => {
          if (this.panel.hidden) {
            this.openPicker();
          } else {
            this.closePicker();
          }
        });

        this.inputs.forEach((input) => {
          input.addEventListener('change', () => this.selectOption(input));
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.desktopQuery.matches && !this.panel.hidden) {
            this.closePicker();
            this.trigger.focus();
          }
        });

        document.addEventListener('click', (event) => {
          if (!this.desktopQuery.matches && !this.contains(event.target) && !this.panel.hidden) {
            this.closePicker();
          }
        });

        this.desktopQuery.addEventListener('change', () => this.syncLayout());
        this.syncLayout();
        this.restoreLinkedVariant();
        this.variantChangeController?.abort();
        this.variantChangeController = new AbortController();
        document.addEventListener('noyoco:variant-change', () => {
          const productRoot = this.closest('kercambre-product');
          if (productRoot?.dataset.sizeExplicit !== 'true') return;
          const selectedInput = this.inputs.find((input) => input.value === String(productRoot.product?.currentVariant?.id));
          if (selectedInput) this.updateCartLabels(selectedInput.dataset.optionLabel);
        }, { signal: this.variantChangeController.signal });
      }

      disconnectedCallback() {
        this.variantChangeController?.abort();
      }

      restoreLinkedVariant() {
        const selectedInput = this.inputs.find((input) => input.value === this.dataset.selectedVariant);
        const productRoot = this.closest('kercambre-product');
        if (!selectedInput || !productRoot || selectedInput.dataset.available !== 'true') {
          this.updateCartLabels();
          return;
        }

        selectedInput.checked = true;
        productRoot.dataset.sizeExplicit = 'true';
        this.statuses.forEach((status) => {
          status.textContent = selectedInput.dataset.optionLabel;
        });
        this.updateCartLabels(selectedInput.dataset.optionLabel);
      }

      syncLayout() {
        if (this.desktopQuery.matches) {
          this.panel.hidden = false;
          this.trigger.setAttribute('aria-expanded', 'true');
        } else {
          this.panel.hidden = true;
          this.trigger.setAttribute('aria-expanded', 'false');
        }
      }

      openPicker() {
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        const firstAvailable = this.inputs.find((input) => input.checked) || this.inputs[0];
        if (firstAvailable) {
          window.requestAnimationFrame(() => firstAvailable.focus());
        }
      }

      closePicker() {
        if (this.desktopQuery.matches) return;
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      selectOption(input) {
        const productRoot = this.closest('kercambre-product');
        if (!productRoot || typeof productRoot.updateVariant !== 'function') return;

        productRoot.dataset.sizeExplicit = 'true';
        productRoot.updateVariant(input.value);
        this.statuses.forEach((status) => {
          status.textContent = input.dataset.optionLabel;
        });
        this.closePicker();
        this.updateCartLabels(input.dataset.optionLabel);
      }

      updateCartLabels(size = '') {
        document.querySelectorAll('#main-atc').forEach((button) => {
          const label = button.querySelector('span');
          if (!label) return;
          label.textContent = size ? `${this.addLabel} — ${size}` : this.chooseLabel;
        });
      }
    }

    customElements.define('noyoco-size-choice', NoyocoSizeChoice);
  }

  if (!window.noyocoSizeChoiceGuard) {
    window.noyocoSizeChoiceGuard = true;

    document.addEventListener('click', (event) => {
      const addToCart = event.target.closest('kercambre-addtocart');
      if (!addToCart) return;

      const productRoot = document.querySelector('kercambre-product');
      const picker = document.querySelector('noyoco-size-choice');
      if (!productRoot || !picker || productRoot.dataset.sizeExplicit === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      picker.openPicker();
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    document.addEventListener('keydown', (event) => {
      const addToCart = event.target.closest('kercambre-addtocart');
      if (!addToCart || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      addToCart.click();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
